import { DubButton } from "@/modules/common/button";
import { DubDialog } from "@/modules/common/dialog";
import { useTranslation } from "next-i18next";
import styled from "@emotion/styled";
import { useEffect } from "react";
import { EVENT, send } from "@/lib/amplitude";
import useDownload from "../useDownload";

const DownloadDialog = ({
  dubbedIdx,
  isDialogOpen,
  setIsDialogOpen,
  locale,
}: any) => {
  const { t } = useTranslation();
  const { handleDownload } = useDownload();
  useEffect(() => {
    if (isDialogOpen) {
      send(EVENT.ENTER__DOWNLOAD_APP_DIALOG, {
        screen: "Dubbed",
        dubbed_idx: dubbedIdx,
      });
    }
  }, [isDialogOpen]);

  const handleClickCancel = (event: any) => {
    send(EVENT.CLOSE__DOWNLOAD_APP_DIALOG, {
      screen: "Dubbed",
      dubbed_idx: dubbedIdx,
    });

    event.stopPropagation();
    setIsDialogOpen(false);
  };

  const handleClickDownload = (event: any) => {
    send(EVENT.CONFIRM__DOWNLOAD_APP_DIALOG, {
      screen: "Dubbed",
      dubbed_idx: dubbedIdx,
    });

    event.stopPropagation();
    handleDownload(locale);
  };

  return (
    <DubDialog
      size="regular"
      open={isDialogOpen}
      body={
        <DialogBody>
          <Header>{t(`dialog_mob_dub_download`)}</Header>
          <Body>{t(`dialog_mob_dub_download_body`)}</Body>
          <Footer>
            <DubButton
              size="regular_mobile"
              variant="fill"
              color="grayMobile"
              fullWidth
              onClick={handleClickCancel}
              style={{ marginRight: "8px" }}
            >
              {t(`button_cancel`)}
            </DubButton>
            <DubButton
              size="regular_mobile"
              variant="fill"
              color="magenta"
              fullWidth
              onClick={handleClickDownload}
            >
              {t(`button_download2dub`)}
            </DubButton>
          </Footer>
        </DialogBody>
      }
    />
  );
};

const DialogBody = styled.div`
  padding: 24px 0 18px 0;
`;

const Header = styled.div`
  padding: 0 24px;
  font-size: var(--fs-h5);
  line-height: var(--lh-h5);
  font-weight: 600;
  color: var(--gray090);
  margin-bottom: 6px;
`;

const Body = styled.div`
  padding: 0 24px;
  font-size: var(--fs-b2);
  line-height: var(--lh-b2);
  font-weight: 400;
  color: var(--gray090);
  margin-bottom: 20px;
`;

const Footer = styled.div`
  padding: 0 18px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default DownloadDialog;
